<template>
	<div class="d-flex flex-column gap-3">
		<div class="d-flex flex-column gap-1">
			<TripMenuItem
				v-for="item in menuItems"
				:key="item.name"
				:name="$t(item.name)"
				:icon="item.icon"
				:is-active="isCurrentRoute(item.view!)"
				@click="item.action()"
				:show-check="true"
				:is-new="item.isNew"
			/>
		</div>
		<div class="d-flex flex-column gap-1">
			<span v-if="!false" class="text-label-s text-neutral-800">
				{{ $t('web.trip.sidebar.store') }}
			</span>
			<template v-for="item in storeMenuItems" :key="item.name">
				<TripMenuItem
					v-if="!item.hide"
					:name="$t(item.name)"
					:icon="item.icon"
					:is-active="isCurrentRoute(item.view!)"
					@click="(item.action(), $emit('close'))"
					:show-check="true"
					:is-new="item.isNew"
				/>
			</template>
		</div>
		<MenuDivider />
		<div class="d-flex flex-column gap-1">
			<template v-for="item in secondaryMenuItems" :key="item.name">
				<TripMenuItem
					v-if="!item.hide"
					:name="$t(item.name)"
					:icon="item.icon"
					@click="(item.action(), $emit('close', 'exit'))"
				/>
			</template>
		</div>
		<MenuDivider />
		<TripMenuItem icon="arrow-left" :name="$t('app.trip.menu.exit')" @click="$emit('exit')" />
	</div>
</template>

<script setup lang="ts">
	import { MenuItem, useTripMenu } from '~/composables/tripMenu'

	const route = useRoute()

	interface Props {
		secondaryMenuItems: MenuItem[]
	}
	defineProps<Props>()
	defineEmits(['open-invitation-dialog', 'open-plan-trip', 'open-request-help', 'close', 'exit'])

	const tripId: string = route.params.itinerary_id as string
	const { menuItems, storeMenuItems } = useTripMenu(tripId)

	const isCurrentRoute = (itemRoute: string) => route.path.includes(`/${itemRoute}`)
</script>

<style scoped lang="scss"></style>
